module.exports = __webpack_public_path__ + "static/media/research_zumkha_img.a9208b07.png";